export enum AssignmentStateTab {
	AllAssignments = 'All Assignments',
	NotStarted = 'Not Started',
	InProgress = 'In Progress',
	Completed = 'Completed',
	Draft = 'Draft',
}
